import request from '@/utils/request'; // 获取审核列表

export function fetchList(data) {
  return request({
    url: '/pmsservice/api/weiXinSuditSwitch/get',
    method: 'post',
    data: data
  });
} // 更新自动审核

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/weiXinSuditSwitch/update',
    method: 'post',
    data: data
  });
}